export function getAllEconomyGroups(axiosPrivate) {
  return axiosPrivate.get('/economy-groups')
}

export function getEconomyGroupById(axiosPrivate, id) {
  return axiosPrivate.get(`/economy-groups/${id}`)
}

export function createEconomyGroup(axiosPrivate, data) {
  return axiosPrivate.post('/economy-groups', data)
}

export function updateEconomyGroup(axiosPrivate, id, data) {
  return axiosPrivate.put(`/economy-groups/${id}`, data)
}

export function deleteEconomyGroup(axiosPrivate, id) {
  return axiosPrivate.delete(`/economy-groups/${id}`)
}
